// Module
var code = "<p><a href=\"https://www.pheaa.org/loan-default/faq#id_e-1mooumk_accordion\">WHAT SHOULD I DO IF MY STUDENT LOAN DEFAULTS?</a></p> ";
// Exports
export default code;